import { MapPinIcon } from "@heroicons/react/24/outline";
import getFlattenText from "common/utils/getFlattenText";
import truncateString from "common/utils/truncateString";
import { Link } from "react-router-dom";
import { Site } from "types";
import useOrganization from "common/hooks/useOrganization";
import ImageComponent from "../ImageComponent/ImageComponent";
import ImageFromStrapiMedia from "../ImageFromStrapiMedia/ImageFromStrapiMedia";
import SiteTypeIcon from "../PostsAndActivities/SiteTypeIcon";
import Status from "../Status/Status";
import Timeline from "../Timeline/Timeline";

interface ISiteChildrenItem {
  item: Site;
}

const iconStyle = "w-4 h-4 text-white";

export default function SiteChildrenItem({ item }: ISiteChildrenItem) {
  const { organization: currentOrganization } = useOrganization();
  const detailLink = `/sites/${item.id}`;

  return (
    <div>
      <Link to={detailLink} className="w-full responsive-flex-lg">
        <div className="flex relative w-full h-40 lg:w-16 lg:h-16 xl:w-24 xl:h-24 shrink-0">
          <div className="absolute -top-2 -left-2">
            <SiteTypeIcon
              labelType={item?.siteType?.name}
              iconStyle={iconStyle}
            />
          </div>
          <div className="rounded-lg overflow-hidden w-full">
            <ImageComponent
              image={
                item.mainImage || item.logo
                  ? ImageFromStrapiMedia(item.mainImage ?? item.logo)?.uri
                  : undefined
              }
            />
          </div>
        </div>

        <div className="flex flex-col flex-1 justify-start lg:pl-4 lg:pr-6 mb-2 mt-2 lg:mt-0">
          <div className="responsive-flex-lg mb-1 gap-3">
            <div className="flex-1">
              <div className="flex flex-row justify-between">
                <h4 className="text-xl font-bold text-primary leading-4">
                  {item.name}
                </h4>
              </div>
              {item.location && (
                <div className="flex items-center gap-1 text-sm my-3">
                  <MapPinIcon className="w-3 h-3" />
                  <span className="font-bold">{item.location}</span>
                </div>
              )}
            </div>
          </div>

          {item.steps?.length > 0 && (
            <div className="w-full my-4">
              <Timeline steps={item.steps || []} />
            </div>
          )}

          {(item.descriptionRich ||
            (item.description && item.description !== "")) && (
            <div
              className={`flex flex-col gap-2 pt-2 mt-2 border-t ${
                item.isDraft ? "border-orange-200" : "border-slate-200"
              }`}
            >
              <div className="text-sm text-slate-500  ">
                {item.descriptionRich
                  ? truncateString(getFlattenText(item.descriptionRich), 150)
                  : truncateString(item.description, 150)}
              </div>
            </div>
          )}

          {!currentOrganization?.isMonoActivity && (
            <div
              className={`flex gap-2 pt-2 mt-4 border-t ${
                item.isDraft ? "border-orange-200" : "border-slate-200"
              }`}
            >
              {!currentOrganization?.isMonoActivity && !!item.siteType && (
                <Status
                  status={item.siteType?.name}
                  color={item.siteType.color}
                  label={item.parent ? item.parent.name : undefined}
                  small
                />
              )}
            </div>
          )}
        </div>
      </Link>
    </div>
  );
}
